import { Component, OnInit } from '@angular/core';
import { PoModule } from '@po-ui/ng-components';
import { LastMenuAcessComponent } from '../last-menu-acess/last-menu-acess.component';
import { Router } from '@angular/router';
import { TenantService } from '../../services/tenant.service';

@Component({
  standalone: true,
  imports: [PoModule, LastMenuAcessComponent],
  selector: 'home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit{
  tenant: string | null = '';

  constructor(
    private router: Router,
    private tenantService: TenantService
  ) {

  }

  ngOnInit() {
    this.tenant = this.tenantService.getTenant();
    if (!this.tenant) {
      this.router.navigate(['/login']);
    }
  }

}
